import { dynamicWrapper, createRoute } from '@/utils/core';

const routesConfig = app => ({
  path: '/sign/change_password',
  title: 'Change Password',
  component: dynamicWrapper(app, [import('./model')], () => import('./components'))
});

export default app => createRoute(app, routesConfig);
